import script from "./Strategys.vue?vue&type=script&lang=ts&setup=true"
export * from "./Strategys.vue?vue&type=script&lang=ts&setup=true"

import "./Strategys.vue?vue&type=style&index=0&id=0b139170&lang=scss"

const __exports__ = script;

export default __exports__